module.exports = __webpack_public_path__ + "img/app4.644b2c5.png";